import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { StringHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/StringHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { ApplicationInformationService } from "@seriously-rad/seriouslyrad-framework-core/RadWindow";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { PageManager } from "@seriously-rad/seriouslyrad-framework-core/Ui/PageManager";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandProcessDesignPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandProcessDesignProperties = {
    [name in keyof EntityCommandProcessDesignPropertyValues]: Property<EntityCommandProcessDesignPropertyValues[name]>
};

export interface IEntityCommandProcessDesign extends IEntityCommand, EntityCommandProcessDesignProperties
{
}

export class EntityCommandProcessDesign extends EntityCommand implements IEntityCommandProcessDesign
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandProcessDesign";
    public static override className = "EntityCommandProcessDesign";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandProcessDesignPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Design",
                entityName: "Process",
                isDefault: true,
                key: "DESIGN",
                permission: PermissionEvaluator.permissionLevels.update,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandProcessDesignPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        recordId = entityCommandInformation.getRecordId();

                    if (!recordId)
                        return;

                    return (
                        PageManager.instance?.navigateAsync(
                            StringHelper.format(
                                "{0}modules/processes/designer/{1}/",
                                ServiceManager.getRequired(ApplicationInformationService).virtualDirectory,
                                recordId
                            )
                        )
                    );
                })
        );
    }

    // #endregion

    // #endregion
}

